import type {QupFrequencyRule} from '@jobseeker/common-core/utils/qupFrequency';

export type QupPlatform = 'web' | 'mobile_web' | 'android' | 'ios';

export const QUP_PAGE_SLUG: Array<[RegExp, string]> = [
  [/^\/job\/applied/, 'successApply'],
  [/^\/registration\/addWorkExperience/, 'onboarding'],
  [/^\/jobfeed/, 'jobfeed'],
];

export const resolveQupSlug = (resolvedUrl: string): string | null => {
  if (!resolvedUrl) return null;
  const path = resolvedUrl.split('?')[0];
  const match = QUP_PAGE_SLUG.find(([pattern]) => pattern.test(path));
  return match ? match[1] : null;
};

export const QUP_CONFIG_BASE_URL = process.env.NEXT_PUBLIC_QUP_CONFIG_URL || '';

export const QUP_CONFIG_TTL_MS = 5 * 60 * 1000;

export const QUP_CONFIG_STALE_MS = 60 * 60 * 1000;

export const QUP_CONFIG_TIMEOUT_MS = 800;

export const QUP_PAGE_VIEW_OPEN_DELAY_MS = 0;

export const QUP_PAGE_VIEW_POINT = 'page_view';

export const QUP_PROFILE_STALE_COHORT = 'profile_stale';

export const QUP_SALARY_BREAKDOWN_COHORT = 'salary_breakdown';

export const QUP_LINKEDIN_SYNC_COHORT = 'linkedin_sync';

export const QUP_COHORT_PRIORITY = [
  QUP_LINKEDIN_SYNC_COHORT,
  QUP_PROFILE_STALE_COHORT,
  QUP_SALARY_BREAKDOWN_COHORT,
] as const;

export const QUP_FREQUENCY_BUCKET: Record<string, string> = {
  [QUP_LINKEDIN_SYNC_COHORT]: QUP_LINKEDIN_SYNC_COHORT,
  [QUP_PROFILE_STALE_COHORT]: QUP_PAGE_VIEW_POINT,
  [QUP_SALARY_BREAKDOWN_COHORT]: QUP_SALARY_BREAKDOWN_COHORT,
};

export const resolveQupFrequencyBucket = (cohort: string): string =>
  QUP_FREQUENCY_BUCKET[cohort] ?? cohort;

export const QUP_LEGACY_COHORT_BY_KEY: Record<string, string> = {
  [QUP_PAGE_VIEW_POINT]: QUP_PROFILE_STALE_COHORT,
  [QUP_SALARY_BREAKDOWN_COHORT]: QUP_SALARY_BREAKDOWN_COHORT,
};

export const resolveLegacyQupCohort = (configKey: string): string | null =>
  QUP_LEGACY_COHORT_BY_KEY[configKey] ?? null;

export const QUP_DEFAULT_CHUNK_SIZE = 3;

export const chunkQupFields = <T>(fields: T[], size: number): T[][] => {
  const width = size > 0 ? size : QUP_DEFAULT_CHUNK_SIZE;
  const chunks: T[][] = [];
  for (let index = 0; index < fields.length; index += width) {
    chunks.push(fields.slice(index, index + width));
  }
  return chunks;
};

const QUP_TEST_EMAILS: string[] =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
    ? []
    : (process.env.NEXT_PUBLIC_QUP_TEST_EMAILS ?? '')
        .split(',')
        .map(email => email.trim().toLowerCase())
        .filter(Boolean);

export const isQupTestUser = (email?: string | null): boolean =>
  !!email && QUP_TEST_EMAILS.includes(email.trim().toLowerCase());

export const QUP_TEST_FREQUENCY: QupFrequencyRule = {
  nonInteractMinGap: 60,
  interactMinGap: 30,
  snoozeTimes: 3,
  freezePeriod: 300,
};

export const QUP_TEST_CHUNK_SIZE = 20;

export const QUP_TEST_SEQUENTIAL_COHORT_DELAY_MS = 1000;
